import * as React from 'react';

export const TrashSvg: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={50} 
    height={50} 
    fill='none'
    viewBox="0 0 50 50" // The main viewing area
  >
    {/* 1. Background Circle/Container */}
    <rect width={49} height={49} x={0.5} y={0.5} stroke='#E8EFF4' rx={24.5} />
    
    {/* 2. Group for Centering */}
    {/* We are moving the 24x24 icon into the center of the 50x50 space.
      (50 / 2) - (24 / 2) = 25 - 12 = 13. 
      Translate (move) the icon 13 units right and 13 units down. 
    */}
    <g transform="translate(13, 13)"> 
      {/* 3. Original 24x24 Icon Paths (using currentColor for dynamic coloring) */}
      <svg 
          viewBox="0 0 24 24" 
          width={24} 
          height={24}
          stroke='#60708E'
          fill="none" 
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round'
      >
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
      </svg>
    </g>
  </svg>
);